export default __webpack_public_path__ + "71884e2099a269e87c36899474265fb4.png";